var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 58,
    viewBox: "0 0 69 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ideas 1",
    clipPath: "url(#clip0_3_912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3522 45.3254H1.69518C1.12749 45.3254 0.666748 44.8685 0.666748 44.3056V21.3487C0.666748 20.7857 1.12749 20.3289 1.69518 20.3289H28.3522C28.9199 20.3289 29.3806 20.7857 29.3806 21.3487V44.3056C29.3806 44.8685 28.9199 45.3254 28.3522 45.3254ZM2.72361 43.2858H27.3237V22.3685H2.72361V43.2858Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.3523 22.3686C28.0644 22.3686 27.7778 22.2489 27.5748 22.0164L21.8362 15.4556H9.09319L2.42346 22.0695C2.02168 22.4679 1.37034 22.4679 0.968567 22.0695C0.566793 21.671 0.566793 21.0252 0.968567 20.6267L7.93997 13.7137C8.13332 13.522 8.39386 13.4146 8.66673 13.4146H22.3065C22.6041 13.4146 22.8879 13.5424 23.084 13.7667L29.1298 20.6798C29.5014 21.1054 29.4562 21.7499 29.027 22.1184C28.8323 22.2857 28.5923 22.3672 28.3537 22.3672L28.3523 22.3686Z",
    fill: "#161718"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.5447 44.3655C45.2062 44.3655 38.4226 37.6387 38.4226 29.37C38.4226 21.1013 45.2062 14.3745 53.5447 14.3745C61.8832 14.3745 68.6668 21.1013 68.6668 29.37C68.6668 37.6387 61.8832 44.3655 53.5447 44.3655ZM53.5447 16.4155C46.3402 16.4155 40.4795 22.2272 40.4795 29.3714C40.4795 36.5156 46.3402 42.3272 53.5447 42.3272C60.7492 42.3272 66.6099 36.5156 66.6099 29.3714C66.6099 22.2272 60.7492 16.4155 53.5447 16.4155Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M63.0777 30.3897C62.51 30.3897 62.0492 29.9328 62.0492 29.3699C62.0492 24.7195 58.2344 20.9366 53.5448 20.9366C52.9771 20.9366 52.5164 20.4797 52.5164 19.9168C52.5164 19.3539 52.9771 18.897 53.5448 18.897C59.3685 18.897 64.1061 23.595 64.1061 29.3699C64.1061 29.9328 63.6454 30.3897 63.0777 30.3897Z",
    fill: "#161718"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.2347 57.8706C33.667 57.8706 33.2063 57.4137 33.2063 56.8508V1.89043C33.2063 1.32749 33.667 0.870605 34.2347 0.870605C34.8024 0.870605 35.2632 1.32749 35.2632 1.89043V56.8508C35.2632 57.4137 34.8024 57.8706 34.2347 57.8706Z",
    fill: "#161718"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 57,
    fill: "white",
    transform: "translate(0.666748 0.870605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeas);
export default __webpack_public_path__ + "static/media/Ideas.f76f77438d5b8d60fc918234205c1b79.svg";
export { ForwardRef as ReactComponent };